import React, { FC } from 'react';

import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { allowExclusiveCheckout as allowExclusiveCheckoutSelector } from '../../utils/selectors';
import { Container as BasketItem } from '../BasketItem';
import {
  useBasketItemDeleteHandler,
  useBasketListPropsAdapter,
  useUpdateItemQuantity,
} from '../CartDrawer/CartDrawerBasketItemList';

import { isSetShoppingBagProduct } from './helpers';
import { ShoppingBagProduct } from './types';

interface BasketItemsWithGenericProps {
  product: ShoppingBagProduct;
  isLastToRender: boolean;
  discounts: ShoppingBagProduct['discount'][];
  shouldRenderDividerBefore: boolean;
  shouldRenderDividerAfter: boolean;
}

const Divider = styled.div`
  width: calc(100% - 32px);
  border-bottom: 1px solid ${props => props.theme.colors.stone};
  margin: 0 16px;
`;
export const BasketItemWithGenericProps: FC<BasketItemsWithGenericProps> = ({
  product,
  isLastToRender,
  discounts,
  shouldRenderDividerBefore,
  shouldRenderDividerAfter,
}) => {
  const {
    pSource,
    location,
    membershipItem,
    showPrice,
    showQuantitySelector,
    showQuantity,
    showRemoveIcon,
  } = useBasketListPropsAdapter();
  const updateItemQuantity = useUpdateItemQuantity();
  const handleDeleteBasketItem = useBasketItemDeleteHandler();

  const allowExclusiveCheckout = useSelector(allowExclusiveCheckoutSelector);

  return (
    <>
      {shouldRenderDividerBefore && <Divider />}
      <BasketItem
        key={product.productId}
        allowExclusiveCheckout={allowExclusiveCheckout}
        deleteBasketItem={handleDeleteBasketItem}
        discounts={discounts}
        hidePreorderMessaging={false}
        isLastToRender={isLastToRender}
        location={location}
        membershipItem={membershipItem}
        product={product}
        shouldDisplayUpsellMessage={false}
        showExclusiveProductMessage={false}
        showQuantity={isSetShoppingBagProduct(product) ? false : showQuantity}
        showQuantitySelector={showQuantitySelector}
        showRemoveIcon={showRemoveIcon}
        showPrice={showPrice}
        showPriceLoading={false}
        updateItemQuantity={updateItemQuantity}
        pSource={pSource}
      />
      {shouldRenderDividerAfter && <Divider />}
    </>
  );
};
